export default __webpack_public_path__ + "static/media/karaoke.cd4ea996.jpg";